import React from 'react';

const SvgMy = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MY_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MY_svg__b" fill="#fff">
        <use xlinkHref="#MY_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#MY_svg__a" />
      <path
        d="M13.333 0H28v1.333H13.333V0zm0 2.667H28V4H13.333V2.667zm0 2.666H28v1.334H13.333V5.333zm0 2.667H28v1.333H13.333V8zM0 10.667h28V12H0v-1.333zm0 2.666h28v1.334H0v-1.334zM0 16h28v1.333H0V16zm0 2.667h28V20H0v-1.333z"
        fill="#E1244A"
        mask="url(#MY_svg__b)"
      />
      <path fill="#0C3F8E" mask="url(#MY_svg__b)" d="M0 0h16v10.667H0z" />
      <path
        d="M9.165 2.21a3.333 3.333 0 1 0 0 6.248 4 4 0 1 1 0-6.248zm1.502 4.217L9.51 7.736l.302-1.721-1.745-.088L9.6 5.09 8.58 3.67l1.611.678.475-1.681.474 1.681 1.61-.677-1.018 1.419 1.533.837-1.745.088.303 1.72-1.157-1.308z"
        fill="#FFD34F"
        mask="url(#MY_svg__b)"
      />
    </g>
  </svg>
);

export default SvgMy;
